import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfilePictureComponent } from './profile-picture/profile-picture.component';
import { InputComponent } from './atoms/input/input.component';
import { ButtonComponent } from './atoms/button/button.component';
import { SCardComponent } from './atoms/card/card.component';
import { SSectionTitleComponent } from './atoms/section-title/section-title.component';
import { SkillSelectorComponent } from './skill-selector/skill-selector.component';
import { SkillsManagerComponent } from './skills-manager/skills-manager.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ProfilePictureComponent, SkillsManagerComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatIconModule,
    MatSelectModule,
    MatDividerModule,
    MatButtonModule,
    MatSnackBarModule,
    MatExpansionModule,
    TranslateModule,
    InputComponent,
    ButtonComponent,
    SCardComponent,
    SSectionTitleComponent,
    SkillSelectorComponent
  ],
  exports: [
    ProfilePictureComponent,
    SkillSelectorComponent,
    SkillsManagerComponent,
    InputComponent,
    ButtonComponent,
    SCardComponent,
    SSectionTitleComponent
  ],
})
export class SharedModule {}
